<template>
  <!--eslint-disable-->
  <div>
    <div id="viewer" style="height: 80vh"></div>
  </div>
</template>

<script>
/* eslint-disable */
import $ from "jquery";
import env from "../../environment";
import storage from "../../storage";

export default {
  mounted() {
    this.initBoldReportViewer();
  },

  computed: {
    supplierInternalId() {
      return this.$store.state.supplierInternalId;
    },
    reportName() {
      return this.$route.params.reportName;
    },
  }, // computed

  methods: {
    initBoldReportViewer() {
      $("#viewer").boldReportViewer({
        parameters: [
          {
            name: "internalId",
            values: [this.supplierInternalId],
          },
        ],
        reportServiceUrl: env.reportServiceUrl,
        reportPath: `${this.reportName}.rdl`,
        ajaxBeforeLoad: (args) => {
          const accessToken = storage.local.getAccessToken();
          args.headers.push({
            Key: "Authorization",
            Value: `Bearer ${accessToken}`,
          });
        },
      });
    },
  }, // methods

  watch: {
    supplierInternalId() {
      this.initBoldReportViewer()
    },
  }, //watch
};
</script>
